<script setup>
// @ts-check
/**
 * @import { PropType } from 'vue'
 * @import { ComponentProps } from './propTypes'
 */
import loginForm from './components/form/LoginForm.vue'
import LayoutArea from '@/studentsite/common/components/LayoutArea/LayoutArea.vue'

defineProps({
  errorList: {
    /** @type {PropType<ComponentProps['errorList']>} */
    type: Object,
    required: true,
  },
})
const baseSignupUrl = /** @type {HTMLInputElement|undefined} */ (document.getElementById('url_signup'))?.value
const pk = new URLSearchParams(window.location.search).get('PK')
let signUpUrl = baseSignupUrl

if (baseSignupUrl && pk) {
  const url = new URL(baseSignupUrl)
  url.searchParams.set('PK', pk)
  signUpUrl = url.toString()
}
</script>

<template>
  <LayoutArea :mode="`simple`">
    <div class="container container--login">
      <div class="titleBar">
        <div class="titleArea">
          <div class="titleSet">
            <div class="title">ログイン</div>
          </div>
        </div>
      </div>
      <div class="contentWrap">
        <loginForm :errorList="errorList" />
        <div class="signupArea">
          <p class="copy">
            まだ会員登録していない方は<a
              :href="signUpUrl"
              class="md_textLink"
              >こちらから登録</a
            >してください
          </p>
        </div>
      </div>
    </div>
  </LayoutArea>
</template>
